import React, { useState, useEffect, useMemo } from "react";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import BASE_URL from "../BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddNewMessageLogModal from "./AddNewMessageLogModal";
import UpdateMessageLogModal from "./UpdateMessageLogModal";
import { Checkbox, DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

function MessageLogs() {
  const history = useHistory();
  const [type, setType] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmailOrLink, setRecipientEmailOrLink] = useState("");
  // const [startDate, setStartDate] = useState(new Date());
  const [messageStatus, setMessageStatus] = useState("");
  const [message, setMessage] = useState("");
  const [description, setDescription] = useState("");
  const [messageLogs, setMessageLogs] = useState([]);
  const [selectedMessageLog, setSelectedMessageLog] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [users, setUsers] = useState([]);
  const [startDate, setStartDate] = useState(new Date()); // Default to current date
  const [newstartDate, newsetStartDate] = useState(new Date()); // Default to current date
  const [endDate, setEndDate] = useState(new Date()); // Default to current date
  const [filteredMessageLogs, setFilteredMessageLogs] = useState([]);
  const [olderThan7DaysCount, setOlderThan7DaysCount] = useState(0);
  const [todayMessagesCount, setTodayMessagesCount] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filteredCount, setFilteredCount] = useState(0);
  const [messages, setMessages] = useState([]); // State for messages
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
  const currentYear = currentDate.getFullYear();
  const [currentMonthUserCount, setCurrentMonthUserCount] = useState(0);
  const [showOlderThan7Days, setShowOlderThan7Days] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [showOlderThan7DaysButton, setShowOlderThan7DaysButton] =
    useState(true);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [userMessageCounts, setUserMessageCounts] = useState({});
  const [previousDateRange, setPreviousDateRange] = useState([null, null]);
  const [previousUser, setPreviousUser] = useState("");

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const currentMonthName = monthNames[currentMonth - 1];
  const monthYearDisplay = `${currentMonthName} ${currentYear}`;
  const currentMonthMessagesCount = messageLogs.filter((log) => {
    const logDate = new Date(log.messageDate);
    return (
      logDate.getMonth() + 1 === currentMonth &&
      logDate.getFullYear() === currentYear
    );
  }).length;

  // const handleCloseClick = () => {
  //   setExpandedRow(null);
  // };

  // Calculate messages for the selected user in the current month
  const filteredMonthCount = messageLogs.filter((log) => {
    const logDate = new Date(log.messageDate);
    return (
      log.recipientName === selectedUser &&
      logDate.getMonth() + 1 === currentMonth &&
      logDate.getFullYear() === currentYear
    );
  }).length;

  // Use useEffect to call the filterMessageLogs function
  useEffect(() => {
    filterMessageLogs();
  }, [messageLogs, selectedUser, startDate, endDate, selectedRecord]);

  // Memoize filtered logs to prevent unnecessary re-renders
  const memoizedFilteredLogs = useMemo(
    () => filteredMessageLogs,
    [filteredMessageLogs]
  );

  useEffect(() => {
    fetchUsers();
    fetchMessageLogs();
    if (!localStorage.getItem("userData")) {
      history.push("/login");
    }
  }, [history]);

  useEffect(() => {
    filterLogsByDateRange();
  }, [startDate, endDate, selectedUser, messageLogs]);

  const filterLogsByDateRange = () => {
    let filteredLogs = messageLogs;

    // If the filter is for older than 7 days, don't apply date range filters
    if (!showOlderThan7Days) {
      // Filter by date range
      if (startDate && endDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0); // Start of the day
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999); // End of the day

        filteredLogs = filteredLogs.filter((log) => {
          const logDate = new Date(log.messageDate);
          return logDate >= start && logDate <= end;
        });
      }

      // Update filtered logs based on selected user
      if (selectedUser && selectedUser !== "") {
        filteredLogs = filteredLogs.filter(
          (log) => log.fullName === selectedUser
        );
      }
    }

    setFilteredMessageLogs(filteredLogs);
    setFilteredCount(filteredLogs.length);

    // Count messages for each user
    const userMessageCounts = users.reduce((acc, user) => {
      acc[user.fullName] = filteredLogs.filter(
        (log) => log.fullName === user.fullName
      ).length;
      return acc;
    }, {});

    setUserMessageCounts(userMessageCounts);

    // Count messages for today if not showing older records
    if (!showOlderThan7Days) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const endToday = new Date();
      endToday.setHours(23, 59, 59, 999);
      const todayLogs = filteredLogs.filter((log) => {
        const logDate = new Date(log.messageDate).getTime();
        return logDate >= today.getTime() && logDate <= endToday.getTime();
      });
      setTodayMessagesCount(todayLogs.length);
    }

    // Count messages for the current month if not showing older records
    if (!showOlderThan7Days) {
      const currentMonthLogs = filteredLogs.filter((log) => {
        const logDate = new Date(log.messageDate);
        return (
          logDate.getMonth() + 1 === new Date().getMonth() + 1 &&
          logDate.getFullYear() === new Date().getFullYear()
        );
      }).length;
      setCurrentMonthUserCount(currentMonthLogs);
    }
  };

  // Fetch users data from API
  const fetchUsers = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData ? userData.groupId : null;

    fetch(`${BASE_URL}/api/Expense/GetAllUsersForDD?GroupID=${groupId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // Define fetchMessageLogs function before useEffect
  const fetchMessageLogs = () => {
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData ? userData.groupId : null;

    fetch(`${BASE_URL}/api/Expense/GetAllMesaageLog?UserID=${groupId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const updatedData = data.map((log) => ({
          ...log,
          incrementedMessageCount: log.threadMessageCount + 1,
        }));
        setMessageLogs(updatedData);

        // Calculate the count of records older than 7 days
        const count = updatedData.filter((log) =>
          isOlderThan7Days(log.messageDate)
        ).length;
        setOlderThan7DaysCount(count);

        // Calculate the count of today's messages
        const todayCount = updatedData.filter((log) =>
          isToday(log.messageDate)
        ).length;
        setTodayMessagesCount(todayCount);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const updateData = (newData) => {
    fetchMessageLogs();
  };

  const isToday = (date) => {
    const today = new Date();
    const logDate = new Date(date);
    return (
      logDate.getDate() === today.getDate() &&
      logDate.getMonth() === today.getMonth() &&
      logDate.getFullYear() === today.getFullYear()
    );
  };

  const handleUserChange = (e) => {
    const selectedUserName = e.target.value;
    setSelectedUser(selectedUserName);

    if (selectedUserName === "All") {
      setFilteredCount(0); // Reset count if "All" is selected
      // Clear the date range filter
      setStartDate(null);
      setEndDate(null);
    } else {
      // Filter messages by selected user
      const userMessages = messages.filter(
        (message) => message.fullName === selectedUserName
      );
      setFilteredCount(userMessages.length);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "type") setType(value);
    if (name === "recipientName") setRecipientName(value);
    if (name === "recipientEmailOrLink") setRecipientEmailOrLink(value);
    if (name === "messageStatus") setMessageStatus(value);
    if (name === "description") setDescription(value);
  };

  const handleDateChange = (date) => {
    newsetStartDate(date);
  };

  // Original filtering function
  const filterMessageLogs = () => {
    let filteredLogs = messageLogs;

    if (selectedUser) {
      filteredLogs = filteredLogs.filter(
        (log) => log.fullName === selectedUser
      );
    }

    if (startDate && endDate) {
      filteredLogs = filteredLogs.filter((log) => {
        const logDate = new Date(log.messageDate);
        return logDate >= startDate && logDate <= endDate;
      });
    }

    // If a record is selected, move it to the top
    if (selectedRecord) {
      filteredLogs = filteredLogs.sort((a, b) => {
        if (a.messageID === selectedRecord.messageID) return -1;
        if (b.messageID === selectedRecord.messageID) return 1;
        return 0;
      });
    }

    setFilteredMessageLogs(filteredLogs);
  };

  const handleUpdate = (newData) => {
    fetchMessageLogs();
  };

  const handleResetForm = () => {
    setSelectedMessageLog(null);
  };

  const handleDeleteClick = (messageId) => {
    Swal.fire({
      title:
        "Are you sure you want to delete this message along with Thread Messages?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(
          `${BASE_URL}/api/Expense/DeleteMesaageLog?messageId=${messageId}`,
          {
            method: "POST",
          }
        )
          .then((response) => response.json())
          .then((data) => {
            Swal.fire("Deleted!", "Your message has been deleted.", "success");
            fetchMessageLogs(); // Fetch the updated message logs
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  };

  const handleViewMessageThread = (
    messageId,
    recipientName,
    recipientEmailOrLink,
    messageStatus
  ) => {
    localStorage.setItem("messageId", messageId);
    localStorage.setItem("recipientName", recipientName);
    localStorage.setItem("recipientEmailOrLink", recipientEmailOrLink);
    localStorage.setItem("messageStatus", messageStatus);
    history.push({
      pathname: "/messageThreads",
      state: { messageId: messageId },
    });
  };

  const handleFollowUpClick = (messageId, followUpCount) => {
    if (followUpCount > 0) {
      fetch(
        `${BASE_URL}/api/Expense/GetTFollowMesaageLogByID?MessageID=${messageId}`,
        // `https://localhost:7208/api/Expense/GetTFollowMesaageLogByID?MessageID=${messageId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("vikas", data);
          if (Array.isArray(data) && data.length > 0) {
            const followUpData = data[0]; // Access the first element if it's an array
            Swal.fire({
              title: "Last Follow Up",
              html: `
                <p><strong>Last Follow Up's Message:</strong> ${getRelativeTime(
                  followUpData.messageDate
                )}</p>
              `,
              confirmButtonText: "Close",
            });
          } else {
            Swal.fire({
              title: "No Data",
              text: "No follow-up data available.",
              confirmButtonText: "Close",
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const handleDateRangeChange = (range) => {
    if (range === null) {
      // Handle the case where range is null
      setStartDate(null);
      setEndDate(null);
      setIsAllSelected(true); // Select the checkbox
    } else {
      // Ensure range has valid elements before accessing
      const [start, end] = range;
      setStartDate(start);
      setEndDate(end);
      setIsAllSelected(false); // Unselect the checkbox
    }
  };

  const handleAllCheckboxChange = (event) => {
    if (event.target.checked) {
      // Save current state before changing
      setPreviousDateRange([startDate, endDate]);
      setPreviousUser(selectedUser);

      // Set to "All"
      setIsAllSelected(true);
      setStartDate(null);
      setEndDate(null);
      setSelectedUser("");
    } else {
      // Restore previous state
      setIsAllSelected(false);
      setStartDate(previousDateRange[0]);
      setEndDate(previousDateRange[1]);
      setSelectedUser(previousUser);
    }
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      // Reset the user dropdown to "All"
      setSelectedUser("All");
      // Reset the date range picker
      setStartDate(null);
      setEndDate(null);
      // Update filtered count if needed
      setFilteredCount(0);
    }
  };
  const handleSubmitModal = () => {
    // Handle submit logic here
    // After successful submit or close
    setShowModal(false); // Close modal
    setSelectedMessageLog(null); // Reset selectedMessageLog state
    fetchMessageLogs(); // Fetch updated message logs
  };
  const getRelativeTime = (date) => {
    const now = new Date();
    const followUpDate = new Date(date);

    // Ensure followUpDate is valid
    if (isNaN(followUpDate.getTime())) {
      return "Invalid date";
    }

    const timeDiff = Math.abs(now - followUpDate); // Difference in milliseconds
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
    const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60)); // Convert milliseconds to hours

    if (daysDiff > 0) {
      return `${daysDiff} day${daysDiff > 1 ? "s" : ""} ago`;
    } else if (hoursDiff > 0) {
      return `${hoursDiff} hour${hoursDiff > 1 ? "s" : ""} ago`;
    } else {
      return "Just now";
    }
  };
  const isOlderThan7Days = (date) => {
    const now = new Date();
    const recordDate = new Date(date);
    const timeDiff = Math.abs(now - recordDate);
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return daysDiff > 7;
  };
  const handleShowOlderThan7Days = () => {
    const now = new Date();
    const olderThan7Days = messageLogs.filter((log) =>
      isOlderThan7Days(log.messageDate)
    );
    setFilteredMessageLogs(olderThan7Days);

    // Update button visibility
    setShowOlderThan7DaysButton(false);
    setShowCloseButton(true);
  };
  const userMessageCounts1 = messageLogs.reduce((acc, log) => {
    if (!acc[log.fullName]) {
      acc[log.fullName] = 0;
    }
    acc[log.fullName]++;
    return acc;
  }, {});
  const handleClose = () => {
    setFilteredMessageLogs([]); // Reset the filtered logs

    // Show the button to filter records older than 7 days
    setShowOlderThan7DaysButton(true);
    setShowCloseButton(false); // Hide the close button
    setShowOlderThan7Days(false); // Hide the filtered records

    // Reset the filtered logs to include records for today or based on selected date
    filterLogsByDateRange();
  };
  return (
    <>
      <style>{`
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px; /* Adjust spacing as needed */
  }
  .header-left {
     flex: 1;
    display: flex;
    align-items: center;
  }
     .header-left h1 {
    margin: 0;
  }
  .header-left span {
    color: gray;
    font-weight: normal;
  }
  .header-right {
    display: flex;
    align-items: center;
  }
  .dropdown {
    // margin-right: 20px; /* Adjust spacing between dropdown and button */
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    
  }
  .button {
    width: 200px;
    height: 40px;
    padding: 8px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .button:hover {
    background-color: #0056b3;
  }
  .bg-red-500 {
    background-color: #f87171; /* Tailwind red-500 */
  }
    .record-count {
    margin-left: 10px;
    font-size: 1rem; /* Adjust font size as needed */
    color: #333; /* Adjust text color as needed */
  }
    @media (max-width: 768px) {
  .header-right {
    flex-direction: column;
  }

  .header-right > * {
    width: 100%;
    max-width: none;
  }
}

.header-container {
  padding: 0 16px;
}

.header-right .dropdown {
  width: 100%;
}


    
`}</style>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <BlockUiOverlay visible={false} />
        <div className="container mx-auto p-4">
          <div
            className={`flex justify-between items-center mb-2 mt-2${
              showModal || showModal2 ? "blur" : ""
            }`}
          >
            <div className="flex items-center">
              <h1 className="text-2xl font-bold mr-4">Messages</h1>{" "}
              {/* Added margin to the right */}
              <div
                className="flex items-center"
                style={{ marginBottom: "-2px" }}
              >
                <span className="mr-4 text-xl md:text-sm">
                  <strong>Total Messages: </strong>
                  <span style={{ color: "rgb(0, 0, 255)" }}>
                    {messageLogs.length}
                  </span>
                </span>
                <span className="mr-4 text-xl md:text-sm">|</span>

                <div className="flex lg:pl-6 lg:mb-0 space-x-4">
                  {Object.entries(userMessageCounts1).map(
                    ([user, count], index) => (
                      <span key={index} className="flex items-center space-x-2">
                        <span
                          style={{ fontSize: "16px" }}
                          className="font-bold"
                        >
                          {user}
                        </span>
                        <span
                          style={{ fontSize: "16px" }}
                          className=" text-blue-600"
                        >
                          : {count}
                        </span>
                        {index <
                          Object.entries(userMessageCounts1).length - 1 && (
                          <span className="mx-2 text-xl md:text-sm">|</span>
                        )}
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>

            <button
              className="px-4 py-2 text-white bg-blue-500 rounded-md text-xs md:text-base font-bold uppercase mb-1 shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 custom-newbutton"
              onClick={() => setShowModal(true)}
            >
              + New Message
            </button>
          </div>
          <div className="flex justify-end items-center mb-2">
            <div className="flex items-end items-center mb-2">
              <input
                type="checkbox"
                id="selectAll"
                checked={isAllSelected}
                onChange={handleAllCheckboxChange}
                className="mr-2"
              />
              <label htmlFor="selectAll" className="mr-4">
                All
              </label>
              <div className="flex items-end">
                <DateRangePicker
                  size="md"
                  format="dd/MM/yy"
                  character=" – "
                  placeholder="Select Date Range"
                  style={{ marginRight: "4px" }}
                  showOneCalendar
                  value={[startDate, endDate]} // Set default value
                  onChange={handleDateRangeChange}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // Center-aligns vertically
                    justifyContent: "center", // Center-aligns horizontally
                  }}
                >
                  <label htmlFor="userDropdown" className="mr-2">
                    Select User
                  </label>
                  <select
                    id="userDropdown"
                    value={selectedUser}
                    onChange={handleUserChange}
                    className="dropdown"
                    style={{
                      width: "auto",
                      minWidth: "150px",
                      maxWidth: "100%",
                    }}
                  >
                    <option value="">All</option>
                    {users.map((user) => (
                      <option key={user.userId} value={user.fullName}>
                        {user.fullName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              {Object.entries(userMessageCounts).map(([userName, count]) => (
                <span key={userName}>
                  {userName}: {count} |{" "}
                </span>
              ))}
            </div>

            {showOlderThan7DaysButton && (
              <button
                className="button"
                title="Follow Up's Pending"
                style={{
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                  padding: "10px 20px", // Adjust padding for better content spacing
                  cursor: "pointer",
                  whiteSpace: "nowrap", // Prevents text from wrapping
                  fontSize: "16px", // Adjust font size if needed
                }}
                onClick={handleShowOlderThan7Days}
              >
                {olderThan7DaysCount}
              </button>
            )}

            {showCloseButton && (
              <button
                className="button"
                style={{
                  backgroundColor: "green",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              >
                Back
              </button>
            )}
          </div>

          <AddNewMessageLogModal
            showModal={showModal}
            setShowModal={setShowModal}
            type={type}
            recipientName={recipientName}
            recipientEmailOrLink={recipientEmailOrLink}
            startDate={newstartDate}
            messageStatus={messageStatus}
            message={message}
            description={description}
            handleInputChange={handleInputChange}
            handleDateChange={handleDateChange}
            handleSubmit={handleSubmitModal} // Pass handleSubmitModal to handle modal close
            selectedMessageLog={selectedMessageLog}
            updateData={updateData}
            resetForm={handleResetForm}
          />
          <UpdateMessageLogModal
            showModal={showModal2}
            setShowModal={setShowModal2}
            selectedMessageLog={selectedMessageLog}
            updateData={handleUpdate}
            resetForm={handleResetForm}
          />

          <div
            className={`overflow-x-auto mt-6 ${
              showModal || showModal2 ? "blur" : ""
            }`}
          >
            <table className="w-full min-w-full">
              <BlockUiOverlay visible={loading} />
              <tbody>
                <tr className="border-b bg-lightBlue-500 text-white">
                  <td className="cell py-2 px-2 font-bold">Type</td>

                  <td className="cell py-2 px-4 font-bold">Recipient</td>
                  <td className="cell py-2 px-4 font-bold">
                    Recipient Email or Links
                  </td>
                  <td className="cell py-2 px-2 font-bold">Sent By</td>
                  {/* <td className="cell py-2 px-2 font-bold">Last Activity</td> */}
                  <td className="cell py-2 px-2 font-bold">Sent On</td>
                  <td className="cell py-2 px-4 font-bold">Status</td>
                  <td className="cell py-2 px-2 font-bold">
                    <img
                      src={require("assets/img/letter.png")} // Replace with the path to your message count icon
                      alt="Total Message Count"
                      title="Total Messages"
                      style={{
                        width: "30px",
                        verticalAlign: "middle",
                        border: "1px solid white", // Adding border to make it more prominent
                        // Adding some padding if needed
                      }}
                    />
                  </td>
                  <td className="cell py-2 px-2 font-bold">
                    <img
                      src={require("assets/img/follow.png")} // Replace with the path to your follow-up icon
                      alt="Follow Up"
                      title="Total Follow Up's"
                      style={{
                        width: "30px",
                        verticalAlign: "middle",
                        border: "1px solid white", // Adding border to make it more prominent
                        // Adding some padding if needed
                      }}
                    />
                  </td>
                  {/* <td className="cell py-2 px-4 font-bold">Description</td> */}
                  <td
                    className="cell py-2 px-2 font-bold"
                    style={{ textAlign: "end" }}
                  >
                    Actions
                  </td>
                </tr>
                {filteredMessageLogs.length > 0 ? (
                  filteredMessageLogs.map((log, index) => (
                    <tr
                      key={index}
                      className={`hover:bg-gray-100 border-b ${
                        isOlderThan7Days(log.messageDate)
                          ? "bg-red-500 text-white"
                          : ""
                      }`}
                    >
                      <td className="cell py-1 px-2" title={log.type}>
                        {log.type}
                      </td>

                      <td
                        className="cell py-1 px-4"
                        title={
                          log.recipientName.length > 10 ? log.recipientName : ""
                        }
                      >
                        {log.recipientName.length > 30
                          ? `${log.recipientName.substring(0, 30)}...`
                          : log.recipientName}
                      </td>

                      <td
                        className="cell py-1 px-4"
                        title={
                          log.recipientEmailOrLink.length > 20
                            ? log.recipientEmailOrLink
                            : ""
                        }
                      >
                        {log.recipientEmailOrLink.length > 40
                          ? `${log.recipientEmailOrLink.substring(0, 40)}...`
                          : log.recipientEmailOrLink}
                      </td>
                      <td className="cell py-1 px-2" title={log.fullName}>
                        {log.fullName}
                      </td>
                      <td
                        className="cell py-1 px-2"
                        title={new Date(log.messageDate)
                          .toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true,
                          })
                          .replace(/am|pm/i, (match) => match.toUpperCase())}
                      >
                        {getRelativeTime(log.messageDate)}
                      </td>

                      <td className="cell py-1 px-4">
                        {log.messageStatus || "Primary Message"}
                      </td>
                      <td
                        onClick={() =>
                          handleViewMessageThread(
                            log.messageID,
                            log.recipientName,
                            log.recipientEmailOrLink,
                            log.messageStatus
                          )
                        }
                        className="cell py-2 px-3 thread-count"
                        style={{
                          cursor:
                            log.threadMessageCount >= 0 ? "pointer" : "default",
                          textDecoration:
                            log.threadMessageCount >= 0 ? "underline" : "none",
                          color:
                            log.threadMessageCount >= 0 ? "blue" : "inherit",
                        }}
                        title={`Message Count: ${
                          Number(log.threadMessageCount) + 1
                        }`} // Tooltip added here
                      >
                        {Number(log.threadMessageCount) + 1}
                      </td>
                      <td
                        className="cell py-2 px-3 follow-ups"
                        style={{
                          cursor: log.followUpCount > 0 ? "pointer" : "default",
                          textDecoration:
                            log.followUpCount > 0 ? "underline" : "none",
                          color: log.followUpCount > 0 ? "blue" : "inherit",
                        }}
                        onClick={() => {
                          if (log.followUpCount > 0) {
                            handleFollowUpClick(
                              log.messageID,
                              log.followUpCount
                            );
                          }
                        }}
                        title={`Follow-up Count: ${log.followUpCount}`} // Tooltip added here
                      >
                        {log.followUpCount}
                      </td>

                      <td className="cell py-1 px-2 flex justify-end">
                        <img
                          title="Manage Thread"
                          src={require("assets/img/MessageThreadIcon.png")}
                          alt="Message Thread"
                          className="mr-2 cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() =>
                            handleViewMessageThread(
                              log.messageID,
                              log.recipientName,
                              log.recipientEmailOrLink,
                              log.messageStatus
                            )
                          }
                        />

                        <img
                          src={require("assets/img/deleteicon.png")}
                          alt="Delete"
                          title="Delete"
                          className="cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => handleDeleteClick(log.messageID)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      className="cell py-2 px-4"
                      colSpan="12"
                      style={{ textAlign: "center" }}
                    >
                      No message logs are available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MessageLogs;
